module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-25-5012d67851431b87a83ca187c1d82bc0.jpg";